module.exports = __webpack_public_path__ + "assets/certificate_pdf/MCSA Office 365_Microsoft Certified Solutions Associate_F111-1705.7d009cfc.pdf";